import { useAuth } from '@/entities/Auth'
import { useHelpers, useTranslate } from '@/shared/lib'

export const useObjectHeader = () => {
  const { user } = useAuth()
  const { filterParents } = useHelpers()
  const { trs } = useTranslate()

  /**
   * Функция вычисления класса иконки в зависимости от статуса
   * @param status
   */
  const getIconClass = (status: number) => {
    switch (status) {
      case 0:
        return 'w-object-header__icon_inactive'
      case 1:
        return 'w-object-header__icon_success'
      case 2:
        return 'w-object-header__icon_warning'
      case 3:
        return 'w-object-header__icon_error'
    }
  }

  /**
   * Функция получения списка для хлебных крошек
   * @param object
   * @param icon
   */
  const getBreadcrumbs = (object: any, icon: null | string = null) => {
    const items: any[] = []
    const parents = filterParents(object.parents, user?.object_group.id || 1)

    parents.forEach((item: any) =>
      items.push({
        title: item.name,
        to: `/objects/groups/${item.id}/monitoring`,
        disabled: false,
      }),
    )

    items.push({ title: object.name, icon: icon || object.object_type.icon })

    return items
  }

  return {
    getIconClass,
    getBreadcrumbs,
  }
}
